export default "__VITE_ASSET__9SRSJHJ8__"